import { render, staticRenderFns } from "./ProjectOrdersDialog.vue?vue&type=template&id=1538005c&scoped=true"
import script from "./ProjectOrdersDialog.vue?vue&type=script&lang=js"
export * from "./ProjectOrdersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1538005c",
  null
  
)

export default component.exports